import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import _ from 'lodash';
import jwt_decode from 'jwt-decode';
import APIService from "@/services/api.service";

Vue.use(Vuex);
function update_vector_count(state) {
  const all_vectors = [...state.draw.getAll().features, ...state.layer_filtered_features]
  const vector_count = _.countBy(all_vectors, vec => vec.properties.class_id)
  for (let v of Object.values(state.vectors)) {
    state.vectors[v.class_id].count = vector_count[v.class_id] || 0;
  }
}

export default new Vuex.Store({
  state: {
    api_host: null,
    claims: {},
    token: null,
    authenticated: false,
    orthos: [],
    map: null,
    draw: null,
    vectors: {},
    active_layer: null,
    layer_features: {},
    layer_filtered_features: [],
    current_mode: null,
    is_continuous_mode: false,
    selected_features: null,
    active_project: null,
    current_organization: {}
  },
  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value;
    },
    SET_API_HOST(state, value) {
      if (value === "therm")
        state.api_host = process.env.VUE_APP_THERM_API_HOST;
      else if (value === "terra")
        state.api_host = process.env.VUE_APP_TERRA_API_HOST;
    },
    SET_TOKEN(state, value) {
      let org = window.$cookies.get("user_organization");
      if (org)
        org = JSON.parse(atob(org));
      this.current_organization = org;
      if (value) {
        state.token = "jwt " + value
        state.claims = jwt_decode(value)
      }
    },
    SET_CLAIMS(state, value) {
      // console.log("~value",value)
      if (value) {
        state.claims = value;
      }
      // console.log("~user_organization",window.$cookies.get("user_organization"))
      let cookies_organization = window.$cookies.get("user_organization");
      if (cookies_organization)
        cookies_organization = JSON.parse(atob(cookies_organization));

      state.current_organization = cookies_organization;

    },
    SET_ORTHOS(state, orthos) {
      let grouped_orthos = {};
      orthos.forEach(element => {
        grouped_orthos[element.groupUid]
          ? grouped_orthos[element.groupUid].push(element)
          : (grouped_orthos[element.groupUid] = [element]);
      });
      state.orthos = Object.values(grouped_orthos);
    },
    INIT_MAP(state, map) {
      state.map = map;
    },
    INIT_DRAW(state, draw) {
      state.draw = draw;
    },
    INIT_VECTORS(state, vectors) {
      state.vectors = vectors;
    },
    LOAD_SOURCES(state) {
      for (let group of state.orthos) {
        for (let project of group) {
          state.map.addSource('MAPSOURCE:' + String(project.projectUid), {
            type: "raster",
            tiles: [`${project.orthoTiles}/{z}/{x}/{y}.png`],
            tileSize: 256
          })
        }
      }
    },
    INIT_FEATURE_COLORS(state, stops) {

      if (!stops || !stops.length) {
        return;
      }


      // POLYGON FILL STYLES
      state.map.setPaintProperty(
        "gl-draw-polygon-fill-active.cold",
        "fill-color",
        {
          property: "user_class_id",
          stops: stops
        }
      );
      state.map.setPaintProperty(
        "gl-draw-polygon-fill-inactive.cold",
        "fill-opacity",
        0
      );
      state.map.setPaintProperty(
        "gl-draw-polygon-fill-inactive.hot",
        "fill-opacity",
        0
      );
      state.map.setPaintProperty(
        "gl-draw-polygon-fill-active.cold",
        "fill-opacity",
        0.25
      );

      state.map.setPaintProperty(
        "gl-draw-polygon-fill-active.hot",
        "fill-color",
        {
          property: "user_class_id",
          stops: stops
        }
      );

      state.map.setPaintProperty(
        "gl-draw-polygon-fill-active.hot",
        "fill-opacity",
        0.25
      );

      // POLYGON LINE STYLES
      state.map.setPaintProperty("gl-draw-polygon-stroke-inactive.cold", "line-color", {
        property: "user_class_id",
        stops: stops
      });

      state.map.setPaintProperty("gl-draw-polygon-stroke-inactive.hot", "line-color", {
        property: "user_class_id",
        stops: stops
      });

      state.map.setPaintProperty("gl-draw-polygon-stroke-active.cold", "line-color", {
        property: "user_class_id",
        stops: stops
      });

      state.map.setPaintProperty("gl-draw-polygon-stroke-active.hot", "line-color", {
        property: "user_class_id",
        stops: stops
      });

      // LINE STYLES
      state.map.setPaintProperty("gl-draw-line-inactive.cold", "line-color", {
        property: "user_class_id",
        stops: stops
      });

      state.map.setPaintProperty("gl-draw-line-inactive.hot", "line-color", {
        property: "user_class_id",
        stops: stops
      });

      state.map.setPaintProperty("gl-draw-line-active.cold", "line-color", {
        property: "user_class_id",
        stops: stops
      });

      state.map.setPaintProperty("gl-draw-line-active.hot", "line-color", {
        property: "user_class_id",
        stops: stops
      });
    },
    TOGGLE_CONTINUOUS_MODE(state) {
      state.is_continuous_mode = !state.is_continuous_mode;
    },
    SET_CURRENT_MODE(state, mode) {
      state.current_mode = mode;
    },
    async SET_ACTIVE_LAYER(state, data) {
      try {
        state.active_project = data.layer;
        let layer = data.layer;
        let is_ctrl = data.is_ctrl;
        let opacity = data.opacity;
        if (!state.map.getSource('MAPSOURCE:' + String(layer.projectUid))) {
          state.map.addSource('MAPSOURCE:' + String(layer.projectUid), {
            type: "raster",
            tiles: [`${layer.orthoTiles}/{z}/{x}/{y}.png`],
            tileSize: 256
          })
        }
        if (state.active_layer && state.map.getLayer("MAPLAYER:" + String(state.active_layer.projectUid))) {
          if (state.layer_features[state.active_layer.projectUid])
            state.layer_features[state.active_layer.projectUid].features =
              [...state.draw.getAll().features, ...state.layer_filtered_features]
          state.map.removeLayer("MAPLAYER:" + String(state.active_layer.projectUid));
          state.layer_filtered_features = [];
        }
        state.active_layer = layer;
        let layer_meta;
        if (state.active_layer.orthoTiles) {
          state.draw.set({ "type": "FeatureCollection", "features": [] });
          layer_meta = await axios.get(state.active_layer.orthoTiles);
          layer_meta = layer_meta.data;
        }

        state.map.addLayer(
          {
            id: "MAPLAYER:" + String(state.active_layer.projectUid),
            type: "raster",
            source: "MAPSOURCE:" + String(state.active_layer.projectUid),
            paint: {
              "raster-opacity": parseInt(opacity, 10) / 100
            }
          },
          "gl-draw-polygon-fill-inactive.cold"
        );
        let features;
        if (!state.layer_features[state.active_layer.projectUid]) {
          features = await (new APIService().get_features(state.active_layer.vectors));
          // state.layer_features[state.active_layer.projectUid] = features.data;
          state.draw.set(features.data);
        }

        if (is_ctrl) {
          // state.map.jumpTo({
          //   center: layer_meta.center.slice(0, 2)
          // })
        }
        else {
          let fly_to_location;
          if (layer_meta && layer_meta.center) {
            fly_to_location = layer_meta.center.slice(0, 2);
          } else
            if (features.data) {
              let centroid = turf.centroid(features.data);
              fly_to_location = centroid.geometry.coordinates;
            }
          state.map.flyTo({
            center: fly_to_location,
            zoom: 18,
            speed: 2.5
          });
        }

        // let features = state.layer_features[state.active_layer.projectUid]
        // state.draw.set(features);

        update_vector_count(state);
      } catch (err) {

        console.log(err)
      }
    },
    ADD_LAYER_FEAURES(state, class_id) {

      const removed_features = _.remove(state.layer_filtered_features, feature => feature.properties.class_id === class_id);
      const geojson = {
        type: "FeatureCollection",
        features: removed_features
      }
      state.draw.add(geojson);

    },
    REMOVE_LAYER_FEAURES(state, class_id) {

      const filtered_features = _.filter(state.draw.getAll().features, feature => feature.properties.class_id === class_id);
      const filtered_featureIds = _.map(filtered_features, feature => feature.id);

      state.draw.delete(filtered_featureIds);
      state.layer_filtered_features = [...state.layer_filtered_features, ...filtered_features];
    },
    UPDATE_VECTOR_COUNT(state) {
      update_vector_count(state)
    },
    SET_SELECTED_FEATURES(state, features) {
      state.selected_features = features;
    }
  },
  actions: {
    set_orthos(context, orthos) {
      context.commit('SET_ORTHOS', orthos)
    },
    init_map(context, map) {
      context.commit('INIT_MAP', map)
    },
    init_draw(context, draw) {
      context.commit('INIT_DRAW', draw);
    },
    init_vectors(context, vectors) {
      context.commit('INIT_VECTORS', vectors);
    },
    load_sources(context) {
      context.commit('LOAD_SOURCES')
    },
    init_feature_colors(context, stops) {
      context.commit("INIT_FEATURE_COLORS", stops);
    },
    toggle_continuous_mode(context) {
      context.commit("TOGGLE_CONTINUOUS_MODE");
    },
    set_current_mode(context, mode) {
      context.commit("SET_CURRENT_MODE", mode)
    },
    set_active_layer(context, data) {
      context.commit("SET_ACTIVE_LAYER", data);
    },
    add_layer_features(context, class_id) {
      context.commit("ADD_LAYER_FEAURES", class_id);
    },
    remove_layer_features(context, class_id) {
      context.commit("REMOVE_LAYER_FEAURES", class_id);
    },
    update_vector_count(context) {
      context.commit("UPDATE_VECTOR_COUNT");
    },
    set_selected_features(context, features) {
      context.commit('SET_SELECTED_FEATURES', features);
    }
  },
  getters: {
    orthos(state) {
      return state.orthos;
    },
    map(state) {
      return state.map;
    },
    draw(state) {
      return state.draw;
    },
    active_layer(state) {
      return state.active_layer;
    },
    vectors(state) {
      return state.vectors;
    },
    features(state) {
      return state.active_layer && state.layer_features[state.active_layer.projectUid];
    },
    filtered_features(state) {
      return state.layer_filtered_features;
    },
    selected_features(state) {
      return state.selected_features;
    },
    current_mode(state) {
      return state.current_mode;
    },
    is_continuous_mode(state) {
      return state.is_continuous_mode
    },
    api_host({ rootState }) {
      return rootState;
    }
  }
})
